export default __webpack_public_path__ + "static/pacman-header-sushishop-a7c1aea9029d3074408353363009c45b.svg";